export default [
  {
    path: '/admin/employee-missions',
    name: 'employee-mission',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mission/employee-mission/index.vue')
  }
]
